import { render, staticRenderFns } from "./ErrorPublicStay.vue?vue&type=template&id=0bf57c00&scoped=true&"
var script = {}
import style0 from "./ErrorPublicStay.vue?vue&type=style&index=0&id=0bf57c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf57c00",
  null
  
)

export default component.exports